<div class="association">
  <app-organisation [organisationId]="parentOrganisationId"></app-organisation>
</div>
